// Company name constants for genericization
export const COMPANY_NAME = 'Design Business'
export const COMPANY_NAME_SHORT = 'Design Business'
export const COMPANY_PAYMENT_METHOD = 'Design Business'
export const COMPANY_CARD = 'Design Business Card'
export const CLIENT_OWES_COMPANY = 'Client Owes Design Business'
export const COMPANY_OWES_CLIENT = 'Design Business Owes Client'
export const COMPANY_INVENTORY = 'Design Business Inventory'
export const COMPANY_INVENTORY_SALE = 'Design Business Inventory Sale'
export const COMPANY_INVENTORY_PURCHASE = 'Design Business Inventory Purchase'
export const COMPANY_DOMAIN_PLACEHOLDER = '<design-business-domain>'
export const COMPANY_INVENTORY_DOMAIN = `inventory.${COMPANY_DOMAIN_PLACEHOLDER}`
export const COMPANY_INVENTORY_URL = `https://inventory.${COMPANY_DOMAIN_PLACEHOLDER}`
export const COMPANY_INVENTORY_TITLE = 'Design Business Inventory & Transactions'
export const COMPANY_PROJECT_PORTAL_LOGO_ALT = 'Design Business Project Portal logo'

